/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import Content from 'app/components/common/Content.jsx';
import FormUtilityMixin from 'app/mixins/FormUtilityMixin.js';
import ErrorModule from 'app/mixins/ErrorModule.jsx';
import CreditCardModal from 'app/components/Subscription/CreditCardModal.jsx';
import StyledSelect from 'app/components/common/StyledSelect.jsx';
import Loading from 'app/components/common/Loading.jsx';
import * as _ from 'underscore';
import UncontrolledTextInput from 'app/components/common/UncontrolledTextInput.jsx';
import EmptyState from 'app/components/common/EmptyState.jsx';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';
import BillingInfoPage from '@/shadcn/components/BillingInfoPage';
import makeToast from 'app/modules/makeToast.js';

class BillingInfo extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            billingInfo: {},
            isEditing: {
                billingContact: false,
                billingAddress: false
            },
            isSaving: {
                billingContact: false,
                billingAddress: false
            },
            contactErrors: null,
            addressErrors: null,
        };

        this.onBeginEdit = this.onBeginEdit.bind(this);
        this.onCancelEdit = this.onCancelEdit.bind(this);
        this.updateEditingState = this.updateEditingState.bind(this);
        this.updateBillingInfo = this.updateBillingInfo.bind(this);
        this.onCountryChange = this.onCountryChange.bind(this);
        this.loadStates = this.loadStates.bind(this);
        this.updatePayment = this.updatePayment.bind(this);

    }

    static getDerivedStateFromProps(props, state) {
        let nextState = {},
            errors = [];

        errors = props.getApiErrors(['SUB_FETCH', 'SUB_FETCH_BILLING', 'SUB_UPDATE_BILLING']);

        if (errors.length) {
            if (state.isSaving.billingContact) {
                nextState.contactErrors = errors[0];
            } else if (state.isSaving.billingAddress) {
                nextState.addressErrors = errors[0];
            }

            nextState.isSaving = {
                billingContact: false,
                billingAddress: false
            };

        } else if (errors.length === 0 && !_.isEmpty(state.errors)) {
            nextState.contactErrors = null;
            nextState.billingErrors = null;
        }

        return (Object.keys(nextState).length) ? nextState : null;
    }


    componentDidMount() {
        let constants = this.props.app.config.constants;

        if (this.props.isFreeUser()) {
            this.props.router.navigate('/account/subscription/new');
        }

        this.props.getPlans();
        this.props.getBillingInfo();
        this.props.getCountries();
        this.props.getSubscription();

        if (this.props.router.query && this.props.router.query.update) {
            this.updatePayment();
        }

    }

    componentDidUpdate(prevProps, prevState) {

        if (_.isEmpty(this.state.billingInfo) && !_.isEmpty(this.props.plans.billingInfo)) {
            this.setState({
                billingInfo: this.props.plans.billingInfo
            });
        }


        if (this.state.addressErrors === null &&
            this.state.contactErrors === null &&
            prevProps.app.loading.SUB_UPDATE_BILLING === true && this.props.app.loading.SUB_UPDATE_BILLING === false) {
            let errors = this.props.getApiErrors(['SUB_UPDATE_BILLING']);
            if (!errors.length) {
                makeToast("Account updated", "success");
                this.props.closeAllModals();
            }
            this.setState({
                billingInfo: this.props.plans.billingInfo,
                isEditing: {
                    billingContact: false,
                    billingAddress: false
                },
                isSaving: {
                    billingContact: false,
                    billingAddress: false
                }
            });
        }

    }

    onBeginEdit(section) {

		this.updateEditingState(section, true);

	}

	onCancelEdit(section) {

		let billingInfo = this.state.billingInfo,
            addressErrors = this.state.addressErrors,
            contactErrors = this.state.contactErrors;

		this.updateEditingState(section, false);

        if (section === 'billingContact') {
            contactErrors = null;
        } else if (section === 'billingAddress') {
            addressErrors = null;
        }

		// reset the value
		billingInfo = _.clone(this.props.plans.billingInfo);

		this.setState({
			billingInfo,
            addressErrors,
            contactErrors
		});

	}

	updateEditingState(key, state) {

		let isEditing = this.state.isEditing;

		isEditing[key] = state;

		this.setState({
			isEditing
		});

	}

    updateBillingInfo(section, billingInfo) {

        let isSaving = this.state.isSaving;

        this.props.updateBillingInfo(billingInfo);

        isSaving[section] = true;

        this.setState({
            isSaving
        });

    }

    onCountryChange(country) {

        let billingInfo = this.state.billingInfo;

        if (country) {
            this.props.getRegions(country);
            billingInfo.country = country;
        }

        this.setState({
            billingInfo
        });

    }

    loadStates() {

        if (this.state.billingInfo.country) {
            this.props.getRegions(this.state.billingInfo.country);
        }

    }

    updatePayment() {

        let ccModal = null,
            first = '',
            last = '',
            parts = [];

        if (this.state.billingInfo.firstName && this.state.billingInfo.lastName) {
            first = this.state.billingInfo.firstName;
            last = this.state.billingInfo.lastName;
        } else {
            parts = this.props.user.detail.username.split("@");
            first = parts[0];
            last = parts[1];
        }

        ccModal = (
            <CreditCardModal
                {...this.props}
                plan={this.props.user.detail.pubLevel}
                planTerm={this.props.plans.current.planTerm}
                planPrice={this.props.plans.current.price}
                firstName={first}
                lastName={last}
                router={this.props.router}
                closeAction={this.props.closeAllModals}
                action='update'
                heading={"Update your Payment Info"}
                version={1}
                errors={this.state.errors} />
        );

        this.props.addModal(ccModal)

    }


    render() {
        let header = null,
            content = null,
            waitingBlock = null;

        const displayError = (errors) => {
            let keys = Object.keys(errors),
                errorMsgs = [];
            if (keys.length) {
                keys.map((key) => {
                    errorMsgs.push(errors[key]);
                });
            }
            return (
                <div className="fieldset-error">
                    <ul className="fieldset-error-list">
                        {errorMsgs.map((msg, i) => {
                            return (
                                <li key={`error-${i}`} className="error-list-item">
                                    {msg}
                                </li>
                            );
                        })}
                    </ul>
                </div>
            );
        };

        if (this.props.user && this.props.user.detail.isAgent) {
            let subaccount = <EmptyState message={"Sorry, only the account owner can access this page."}/>
            return (
                <Content header={header} main={subaccount}/>
            );
        }

        if (this.props.app.loading.SUB_FETCH_BILLING || _.isEmpty(this.state.billingInfo) || this.props.app.loading.SUB_FETCH_PLANS) {
            waitingBlock = (
                <Loading/>
            );
            return (<Content header={header} main={waitingBlock}/>);
        }

        content = (
            <div className="tw-root">
                <BillingInfoPage
                    {...this.props}
                    isEditing={this.state.isEditing}
                    billingInfo={this.state.billingInfo}
                    countries={this.props.utilities.countries}
                    states={this.props.utilities.regions}
                    onBeginEdit={this.onBeginEdit}
                    onCancelEdit={this.onCancelEdit}
                    onUpdatePayment={this.updatePayment}
                    onCountryChange={this.onCountryChange}
                    onSaveContact={(billingInfo) => {
                        this.updateBillingInfo("billingContact", billingInfo)
                    }}
                    onSaveAddress={(billingInfo) => {
                        this.updateBillingInfo("billingAddress", billingInfo)
                    }}/>
            </div>
        );

        return (
            <Content header={null} main={content} />
        );
    }

};

BillingInfo.displayName = "BillingInfo";

export default ComponentWithContext(BillingInfo);
